// DataToolbar — barre d'outils de liste STANDARD (Design System) : recherche rapide +
// filtres + actions + compteur de résultats. Responsive (repli mobile propre). La logique
// de recherche/pagination est portée par le hook useServerTable ; ce composant est présentatif.
import React from 'react';
import './DataToolbar.css';

const DataToolbar = ({
  search,
  onSearchChange,
  searchPlaceholder = 'Rechercher…',
  filters,            // ReactNode (selects de filtres)
  actions,            // ReactNode (export, nouveau…)
  total,              // nombre total de résultats (serveur)
  loading = false,
}) => {
  return (
    <div className="data-toolbar">
      <div className="data-toolbar__search">
        <span className="data-toolbar__search-icon" aria-hidden="true">🔎</span>
        <input
          type="search"
          className="data-toolbar__input"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={searchPlaceholder}
          aria-label={searchPlaceholder}
        />
        {loading && <span className="data-toolbar__spinner" aria-hidden="true" />}
      </div>

      {filters && <div className="data-toolbar__filters">{filters}</div>}

      <div className="data-toolbar__right">
        {typeof total === 'number' && (
          <span className="data-toolbar__count">{total.toLocaleString('fr-FR')}</span>
        )}
        {actions && <div className="data-toolbar__actions">{actions}</div>}
      </div>
    </div>
  );
};

export default DataToolbar;
